export default __webpack_public_path__ + "img/status/new.png";